import { useSelector } from 'react-redux';

export const useMatricula = () =>
  useSelector((state) => state.user.data?.matricula);

export const useToken = () => useSelector((state) => state.user.data?.token);

export const usePlano = () => useSelector((state) => state.user.data?.plano);

export const useUserData = () => useSelector((state) => state.user.data);

export const useDadosPessoais = () =>
  useSelector((state) => state.user.dadosPessoais);

export const useIsLogged = () => useSelector((state) => state.user.isLogged);

export const useEnvioRequerimentoLoading = () =>
  useSelector((state) => state.requerimentos.envio.loading);

export const useFormulariosRequerimento = () =>
  useSelector((state) => ({
    allForms: state.requerimentos.allForms,
    allFormsRequestDone: state.requerimentos.allFormsRequestDone,
  }));

export const useLimiteLoan = () => useSelector((state) => state.loan.limite);
